import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBackpack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBackpack"><Path fillRule="evenodd" clipRule="evenodd" d="M8 1H16V4H21V8C21 9.01445 20.6224 9.94069 20 10.6458V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V10.6458C3.37764 9.94069 3 9.01445 3 8V4H8V1ZM10 4H14V3H10V4ZM6 11.874V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V11.874C17.6804 11.9562 17.3453 12 17 12H16V14H14V12H10V14H8V12H7C6.6547 12 6.31962 11.9562 6 11.874ZM9 16H15V18H9V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBackpack;
